/**
 * Suppress known React 18 deprecation warnings from legacy third-party libraries.
 *
 * - reactstrap v7 uses `defaultProps` on function components, which React 18 warns about.
 *   This is a known upstream issue. Suppressed here until reactstrap is upgraded.
 */
const originalConsoleError = console.error.bind(console)

console.error = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : ''

  // Suppress React 18 defaultProps-on-function-component deprecation from old libraries
  if (msg.includes('Support for defaultProps will be removed from function components')) {
    return
  }

  originalConsoleError(...args)
}
